<template>
    <div class="row" v-if="is_authenticated">
      <!-- <div class="col-12">
        <div class="alert alert-info text-center" role="alert" v-show="alert_running">
          Alert is currently playing
        </div>
        <div class="alert alert-warning text-center" role="alert" v-show="default_schedule_expires_soon">
          <b>Notice:</b> The default schedule expires soon or has already expired, please update the start date by clicking <router-link :to="{ name: 'DefaultScheduler' }" >here</router-link>.
        </div>
      </div> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data: function () {
    return {
      alert_running: false
    }
  },
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      default_schedule: 'getDefaultSchedule'
    }),
    default_schedule_expires_soon () {
      let currentDate = moment()
      let notificationDate = moment(this.default_schedule.start_date).add(11, 'M')
      if (currentDate > notificationDate) {
        return true
      }
      return false
    }
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.$store.dispatch('getDefaultSchedule')
    }
  },
  created () {
    this.$store.dispatch('getDefaultSchedule')
  },
  sockets: {
    message (data) {
      if (data.type === 'alert') {
        if (data.running === true) {
          this.alert_running = true
        } else {
          this.alert_running = false
        }
      }
    }
  }
}
</script>
